import { AlertTriangle } from "lucide-react";
import { Button } from "@/shared/ui/Button";

const ErrorFallback = () => {
  const handleRedirect = () => {
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12 text-center">
      <AlertTriangle
        size={68}
        className="text-red-500 mb-6"
      />

      <h1 className="text-5xl font-extrabold text-gray-900 mb-4">500</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-2">Erreur serveur</h2>
      <p className="text-gray-500 max-w-md mb-6">
        Une erreur inattendue s'est produite. Veuillez rafraîchir la page ou réessayer plus tard.
      </p>

      <Button
        onClick={handleRedirect}
        variant="action"
      >
        Retour au tableau de bord
      </Button>

      <div className="mt-12 text-sm text-gray-300">
        YeatiMini © - Onlyce ©
        {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default ErrorFallback;
